import React, { useEffect, useRef } from 'react';

const HowItWorks = () => {
  const stepRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in');
        }
      });
    }, observerOptions);

    stepRefs.current.forEach(el => {
      if (el) observer.observe(el);
    });

    return () => {
      stepRefs.current.forEach(el => {
        if (el) observer.unobserve(el);
      });
    };
  }, []);

  const steps = [
    {
      number: 1,
      title: 'Enter Amount',
      description: 'Input the amount you want to calculate VAT for in the designated field.'
    },
    {
      number: 2,
      title: 'Set VAT Rate',
      description: 'Choose your VAT rate percentage or use our quick preset buttons for common rates.'
    },
    {
      number: 3,
      title: 'Get Results',
      description: 'Instantly see the VAT amount and total with all calculations broken down clearly.'
    }
  ];

  return (
    <section className="how-it-works" id="how-it-works">
      <div className="steps-container">
        <h2 className="section-title">How It Works</h2>
        <p className="section-subtitle">Calculate VAT in three simple steps</p>

        <div className="steps">
          {steps.map((step, index) => (
            <div
              key={step.number}
              className="step"
              ref={el => stepRefs.current[index] = el}
            >
              <div className="step-number">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
